import { BalancesConstants } from '../utils/balances-constants';

export interface QuoteOption {
    label: string;
    value: string;
}

export interface QuoteOptions {
    options: QuoteOption[];
    defaultValue: string;
}

export const DEFAULT_QUOTE_OPTIONS = {
    options: [
            { label: 'Prior Day', value: BalancesConstants.PRIORDAY },
            { label: 'Delayed (15 mins)', value: BalancesConstants.DELAYED }
        ],
    account: {
        defaultValue: BalancesConstants.DELAYED
    },
    household: {
        defaultValue: BalancesConstants.DELAYED
    },
    group: {
        defaultValue: BalancesConstants.DELAYED
    },
    client: {
        defaultValue: BalancesConstants.DELAYED
    }
};

export const ENTITLED_QUOTE_OPTIONS = {
    options: [
            { label: 'Prior Day', value: BalancesConstants.PRIORDAY },
            { label: 'Delayed (15 mins)', value: BalancesConstants.DELAYED },
            { label: 'Real Time', value: BalancesConstants.REALTIME }
        ],
    account: {
        defaultValue: BalancesConstants.DELAYED
    },
    household: {
        defaultValue: BalancesConstants.DELAYED
    },
    group: {
        defaultValue: BalancesConstants.DELAYED
    },
    client: {
        defaultValue: BalancesConstants.DELAYED
    }
};
